import React, { useEffect, useState } from "react";
import { open_api_with_cookies } from "../../Utils/network";
import coupon from "../../assets/Icons/coupon.svg";
import couponredeemed from "../../assets/Icons/couponredeemed.svg";
import amount from "../../assets/Icons/amount.svg";
import info from "../../assets/Icons/info.svg";
import StatsCard from "../../components/Card/StatsCard";
import FilterChip from "../../components/Chip/FilterChip";
import DateRangeChip from "../../components/Chip/DateRangeChip";
import SearchBar from "../../components/Search/SearchBar";
import TableCard from "../../components/Card/TableCard";
import { addAlert, removeAlert } from "../../Utils/helper";
import { useCallback } from "react";
import AddCoupon from "./CouponDetails";
import "./Coupons.css";
import Cookies from "js-cookie";
import Infocard from "../../components/Infocard/Infocard";

const activeState = ["All", "Active", "Inactive"];

const statusMap = {
  Active: "True",
  Inactive: "False",
};

export default function Coupons() {
  const [couponsStats, setCouponStats] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [couponId, setCouponId] = useState("");
  const [packagesList, setPackagesList] = useState([]);
  const [packagesListFromApi, setPackagesListFromApi] = useState(null);
  const [alerts, setAlerts] = useState([]); // Holds multiple alerts
  const [showAlert, setShowAlert] = useState(false); // Controls visibility of alerts
  const [refreshKey, setRefreshKey] = useState(0);
  const [expertSlug, setExpertSlug] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);

  const handleClick = useCallback((event) => {
    console.log(event.target.id);
    setShowCoupon((prev) => !prev);
    setCouponId(parseInt(event.target.id));
  }, []);

  const id = Cookies.get("expertID");
  const getLeadsStats = async () => {
    const result = await open_api_with_cookies.get(
      `coupon/dashboard/bookings/overview/${id}/`
    );
    console.log(result);
    if (result.status == 200 && result.data != null) {
      setCouponStats([
        {
          icon: coupon,
          title: "Total Coupons",
          value: result.data.total_coupons,
        },
        {
          icon: couponredeemed,
          title: "Total Coupons Reedemed",
          value: result.data.total_redeemed_coupons,
        },
        {
          icon: amount,
          title: "Total Revenue from coupon",
          value: result.data.total_coupon_revenue,
          info: info,
          infocard: <Infocard content={content}></Infocard>,
          amount: "₹",
        },
      ]);
    }
  };
  const [selectedOption, setSelectedOption] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [options, setOptions] = useState(["All"]);
  const [isLoading, setLoading] = useState(false);
  const [packages, setPackages] = useState([]);

  const columns = [
    { header: "Coupon Code", accessor: "code" },
    { header: "Discount Type", accessor: "discount_type" },
    { header: "Discount", accessor: "discount" },
    { header: "Valid From ", accessor: "from_date" },
    { header: "Valid Till ", accessor: "to_date" },
    { header: "Active", accessor: "is_visible" },
    { header: "", accessor: "details" },
  ];

  const content = [
    "This is the revenue after commission cut by myburgo",
    "The revenue doesnt take into account the discount from USD",
  ];

  const isValidResponse = (result) => {
    if (
      (result.status === 200 || result.status === 201) &&
      result.data !== null &&
      result.data !== undefined
    ) {
      console.log(result.data);
      setTableData(result.data.results);
      setTotalPages(Math.ceil(result.data.results.length / 10));
      setTotalEntries(result.data.results.length);
    }
  };

  const setData = (data) => {
    setTableData(data);
  };
  console.log("he;;p");
  const getType = async () => {
    const result = await open_api_with_cookies.get(
      `/session/all-packages/?expert=${id}`
    );
    console.log(result);
    setPackages(result.data.data);
    const filteredData = new Set(result.data.data.map((res) => res.title));
    var data = [...filteredData];
    setOptions(["All", ...data]);
    console.log(options);
  };

  const filters = async () => {
    setLoading(true);

    try {
      let url = `/coupon/dashboard/bookings/list/${id}/?valid_from=${
        startDate || ""
      }&valid_to=${endDate || ""}&search=${searchQuery}&is_active=${
        selectedStatus == "All" ? "" : statusMap[selectedStatus]
      }`;

      if (selectedOption !== "All") {
        const selectedPackage = packages.find(
          (pkg) => pkg.title === selectedOption
        );
        if (selectedPackage) {
          url += `&package_id=${selectedPackage.id}`;
        }
      }

      const result = await open_api_with_cookies.get(url);
      isValidResponse(result);
    } catch (error) {
      console.error("Error fetching filtered data", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const createDateString = (date) => {
    const required_date = new Date(date);
    const month =
      required_date.getMonth() + 1 < 10
        ? `0${required_date.getMonth() + 1}`
        : required_date.getMonth() + 1;
    const day =
      required_date.getDate() < 10
        ? `0${required_date.getDate()}`
        : required_date.getDate();
    const date_string = `${required_date.getFullYear()}-${month}-${day}`;
    return date_string;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSelect = (option) => {
    setSelectedOption(option);
    setCurrentPage(1);
  };

  const handleSelectStatus = (option) => {
    setSelectedStatus(option);
    setCurrentPage(1);
  };

  const handleAddAlert = (title, message, type, autoClose = false) => {
    addAlert(title, message, type, autoClose, setAlerts);
    setShowAlert(true); // Show alert when adding a new alert
  };

  const handleDateChange = (start, end) => {
    const updatedStartDate = start !== null ? createDateString(start) : null;
    const updatedEndDate = end !== null ? createDateString(end) : null;

    setStartDate(updatedStartDate);
    setEndDate(updatedEndDate);
    setCurrentPage(1);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleSubmitStatus = (status, message) => {
    setRefreshKey((prev) => prev + 1);
    if (status === "success") {
      handleAddAlert("Action Successful", message, "success", true);
    } else {
      handleAddAlert("Action Failure", message, "error", true);
    }
  };

  useEffect(() => {
    getType();
    console.log(tableData);
  }, []);

  useEffect(() => {
    filters();
  }, [selectedOption, searchQuery, startDate, endDate, selectedStatus]);

  useEffect(() => {
    getLeadsStats();
  }, []);

  return (
    <div className="coupon-container">
      <section className="stats-card-container-leads">
        <p className="subtitle">One on One Booking Coupons</p>
        <StatsCard data={couponsStats} content={content}></StatsCard>
      </section>
      <div className="filters-container">
        <FilterChip
          options={options}
          selected={selectedOption}
          onSelect={handleSelect}
        />
        <FilterChip
          options={activeState}
          selected={selectedStatus}
          onSelect={handleSelectStatus}
        />
        <DateRangeChip
          label="Select Date Range"
          onDateChange={handleDateChange}
        />

        <div className="search-container">
          <SearchBar onSearch={handleSearch} />
        </div>
      </div>
      <div className="all-bookings-table-container">
        <TableCard
          columns={columns}
          data={tableData}
          totalEntries={totalEntries}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          isClickable={true}
          loading={isLoading}
          isShowJoinButton={false}
          handleClick={handleClick}
          setData={setData}
          isCoupon={true}
        />
      </div>
      {showCoupon && (
        <AddCoupon onClose={handleClick} expertId={id} couponId={couponId} />
      )}
    </div>
  );
}
